import localFont from 'next/font/local';

export const MonoRelativeFont = localFont({
  src: [{ path: './relative-pro-faux.otf', style: 'normal' }],
});

export const BodyRelativeFont = localFont({
  src: [
    { path: './relative-pro-bold.otf', weight: '700' },
    { path: './relative-pro-book.otf', style: 'normal' },
  ],
});

export const BodyRelative = BodyRelativeFont.style.fontFamily;
export const MonoRelative = MonoRelativeFont.style.fontFamily;
